






































import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Typings
import {
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";

@Component
export default class TicketDepartmentDropdown extends Mixins(Context) {
  // Injected
  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: ITicketProviderMethods;

  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;

  // Data
  public isProcessing = false;

  // Getters
  public get ticketData() {
    return this.$ticketData();
  }

  public async changeDepartment(departmentId) {
    if (this.ticketData.isProcessing) return;
    this.isProcessing = true;
    try {
      await this.$ticketMethods.changeDepartment(departmentId);
    } finally {
      this.isProcessing = false;
    }
  }

  public get departmentName() {
    return this.$_.get(
      this.$_.find(this.ticketData.ticketDepartments, [
        "id",
        this.$_.get(this.ticketData.ticket, "ticket_department_id")
      ]),
      "name"
    );
  }

  public get filteredDepartments() {
    return this.ticketData.ticketDepartments;
  }
}
